import { importDipsResources } from '~/store/dips-entity.api'

import { MultiQueryOptions, useMultiQuery } from '../useMultiQuery'

/**
 * Fetch DIPS resources V2 (MainSurgeon and OperatingTheater) and put them in the store.
 *
 * @param options - (Optional) Parameters for the queries, such as skip and refetchInterval.
 */
export const useResourceQueries = (options?: MultiQueryOptions) => {
    const resourceQueries = useMultiQuery(
        [
            { queryFn: () => importDipsResources('MainSurgeon'), queryKey: ['mainSurgeons'] },
            { queryFn: () => importDipsResources('OperatingTheater'), queryKey: ['operatingTheaters'] },
        ],
        options
    )

    return resourceQueries
}
